import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import {
  OverTimeUnsegmentedVizData,
  OverTimeUnsegmentedVizExternalProps,
} from '../../types';
import { overTimeUnsegmentedLineChartDataToUiComponentProps } from './dataToUiComponentProps';
import {
  OverTimeUnsegmentedLineChartActions,
  OverTimeUnsegmentedLineChartState,
  OverTimeUnsegmentedLineChartUiComponentProps,
} from './types';
import { OverTimeUnsegmentedLineChartUiComponent } from './UiComponent';
import { useOverTimeUnsegmentedLineChartStateManager } from './useStateManager';

export const overTimeUnsegmentedLineChartViewConfig: DataVizContainerViewConfigWithStateManager<
  OverTimeUnsegmentedVizData,
  OverTimeUnsegmentedVizExternalProps,
  OverTimeUnsegmentedLineChartUiComponentProps,
  OverTimeUnsegmentedLineChartState,
  OverTimeUnsegmentedLineChartActions
> = {
  hasStateManager: true,
  useStateManager: useOverTimeUnsegmentedLineChartStateManager,
  dataToUiComponentProps: overTimeUnsegmentedLineChartDataToUiComponentProps,
  UiComponent: OverTimeUnsegmentedLineChartUiComponent,
};
